var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(-1499 -2697)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Intersection_1",
    "data-name": "Intersection 1",
    d: "M5,48a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0H43a5,5,0,0,1,5,5V43a5,5,0,0,1-5,5Zm7.616-7.8a7.063,7.063,0,0,0,2.648,3.034,8.8,8.8,0,0,0,6.413.81A5.618,5.618,0,0,0,25.3,41.224c1.02-1.86.8-4.14.794-6.692.014-2.489.012-4.979.005-8.106,0-.994-.005-2.62-.005-4.252l.008-.112h-4.5c0,3.876-.018,7.728-.018,11.61,0,2.464.126,4.726-.275,5.422-.661,1.378-2.36,1.2-3.132.96a3.865,3.865,0,0,1-1.66-1.71,1.727,1.727,0,0,0-.254-.392Zm15.849-.694a8.1,8.1,0,0,0,1.62,2.218c3.48,3.512,12.181,3.332,13.742-2.008a6.771,6.771,0,0,0,.148-3.3l.092.134c-.35-2.19-1.776-4.03-6.006-5.747-1.472-.689-3.109-1.17-3.595-2.28a2.362,2.362,0,0,1-.092-1.409c.3-1.292,1.83-1.68,3.03-1.32a3.257,3.257,0,0,1,1.952,1.8c2.067-1.352,2.067-1.352,3.51-2.25a8.211,8.211,0,0,0-1.173-1.56c-1.26-1.41-2.938-2.13-5.667-2.068l-1.41.178a6.443,6.443,0,0,0-3.42,2.01,6.275,6.275,0,0,0,1.138,8.942c2.731,2.04,6.722,2.488,7.232,4.41.48,2.34-1.74,3.091-3.932,2.821a5.268,5.268,0,0,1-3.51-2.672Z",
    transform: "translate(1499 2697)",
    fill: "#ffb400"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs);
export default __webpack_public_path__ + "static/media/JS.c7f4c028cfc100addbcc1b795c0e959a.svg";
export { ForwardRef as ReactComponent };